import Component from '../core/Component'
import $ from 'jquery'
import { loadComponents } from '../core/componentUtils';

$('body').find('.popup').on('click', event => {
    event.stopPropagation()
})

export default class PopupOpener extends Component {
    constructor($element) {
        super($element)
        this.link = this.$element.attr('href')
    }

    prepare() {
        var self = this
        this.$element.on('click', event => {
            event.preventDefault()
            $('body').css('overflow', 'hidden');

            $.ajax({url: this.link, success: function(result){
                $('body').append($(result).find('.popup-wrap'))

                loadComponents($('.popup-wrap'))

                // close
                $('body').find('.popup-close').on('click', event => {
                    event.preventDefault()
                    $('.popup-wrap').remove()
                    $('body').css('overflow', 'visible');
                })
                $('body').find('.popup-wrap').on('click', event => {
                    event.preventDefault()
                    $('.popup-wrap').remove()
                    $('body').css('overflow', 'visible');
                })
                $('body').find('.popup').on('click', event => {
                    event.stopPropagation()
                })

                // arrows
                $('body').find('.service-pagination__arrow').on('click', event => {
                    $('.popup-wrap').remove()
                })
            }});
        })
    }
}


// WEBPACK FOOTER //
// ./components/PopupOpener.js